import { Module } from '@nestjs/common';
import { AssetsClassificationAdapter } from './assets-classification-adpater';
import { AssetsClassification } from './assets-classification-entity';
import { AssetsClassificationController } from './assets-classification.controller';
import { AssetsClassificationService } from './assets-classification.service';
import { TypeOrmModule } from '@nestjs/typeorm';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';

@Module({
  imports: [
    TypeOrmModule.forFeature([AssetsClassification]),

  ],
  controllers: [AssetsClassificationController],
  providers: [AssetsClassificationService, AssetsClassificationAdapter,ApplicationExceptionHandler]
})
export class AssetsClassificationModule { }
